module.exports = __webpack_public_path__ + "static/media/cloudcampusl-9-04.0c233ce3.png";